import styled from 'styled-components'

export const Header = styled.div<TSFixMe>`
  padding: 13px 20px;
  background-color: #f8f8f8;
  border-top-right-radius: 10px;
  border-top-left-radius: 10px;
`

export const Title = styled.h4<TSFixMe>`
  font-size: 16px;
  text-transform: uppercase;
  font-weight: 500;
  margin: 0;
  letter-spacing: 1.33px;
  color: #273339;
`

export const Content = styled.div<TSFixMe>`
  overflow: auto;
  padding: 10px 20px;
`

export const Table = styled.table<TSFixMe>`
  width: 100%;
  border-collapse: collapse;
`

export const Th = styled.th<TSFixMe>`
  padding: 10px 5px;
  border-bottom: 2px solid #c6c6c6;
  text-transform: uppercase;
  text-align: left;
  color: #263238;

  :first-child {
    padding: 10px 5px 10px 0;
  }

  :last-child {
    padding: 10px 0 10px 5px;
  }
`

export const Tr = styled.tr<TSFixMe>`
  td {
    padding-top: 7px;
    padding-bottom: 7px;
  }

  :first-child {
    td {
      padding-top: 15px;
      padding-bottom: 7px;
    }
  }

  :last-child {
    td {
      padding-top: 7px;
      padding-bottom: 15px;
    }
  }
`

export const Td = styled.td<TSFixMe>`
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  max-width: 100px;
  padding-left: 5px;
  padding-right: 5px;
  text-align: ${(props): TSFixMe => (props.right ? 'right' : 'left')};

  :first-child {
    padding-left: 0;
  }

  :last-child {
    padding-right: 0;
  }
`
